var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.933533 0.93451C1.24595 0.62209 1.75248 0.62209 2.0649 0.93451L6.99922 5.86882L11.9335 0.93451L12.2155 1.21646L11.9335 0.934509C12.246 0.622091 12.7525 0.622091 13.0649 0.934509C13.3773 1.24693 13.3773 1.75346 13.0649 2.06588L8.13059 7.0002L13.0649 11.9345C13.3773 12.2469 13.3773 12.7535 13.0649 13.0659L12.7114 12.7123L13.0649 13.0659C12.7525 13.3783 12.246 13.3783 11.9335 13.0659L6.99922 8.13157L2.0649 13.0659C1.75248 13.3783 1.24595 13.3783 0.933532 13.0659C0.621114 12.7535 0.621114 12.2469 0.933532 11.9345L1.28709 12.2881L0.933533 11.9345L5.86785 7.0002L0.933533 2.06588C0.621114 1.75346 0.621114 1.24693 0.933533 0.93451Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.10e411e3.svg";
export { ForwardRef as ReactComponent };